export const DOWNLOAD_DOCUMENT_SUCCESS = 'DOWNLOAD_DOCUMENT_SUCCESS';

export const downloadDocumentSuccess = document => ({
    type: DOWNLOAD_DOCUMENT_SUCCESS,
    payload: { document },
});
